import {
    CLUBS_FETCH,
    CLUBS_FETCH_SUCCESS,
    CLUBS_FETCH_FAILURE,
    CLUBS_ORGANIZER_FETCH,
    CLUBS_ORGANIZER_FETCH_SUCCESS,
    CLUBS_ORGANIZER_FETCH_FAILURE,
    CLUBS_LATEST_EVENT_FETCH,
    CLUBS_LATEST_EVENT_FETCH_SUCCESS,
    CLUBS_LATEST_EVENT_FETCH_FAILURE,
} from '../actions/club-actions';

const initialState = {
    isLoading: false,
    clubsLoaded: false,
    clubs: [],
    clubLatestEventsLoaded: false,
    clubLatestEvents: [],
    clubOrganizersLoaded: false,
    clubOrganizers: {},
};

function app(state = initialState, action) {
    switch (action.type) {
        case CLUBS_FETCH:
            return {
                ...state,
                isLoading: true,
                clubsLoaded: false,
            };
        case CLUBS_FETCH_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                clubsLoaded: true,
                clubs: action.data,
            };
        }
        case CLUBS_FETCH_FAILURE:
            return {
                ...state,
                isLoading: false,
                clubsLoaded: false,
                clubs: [],
            };

        case CLUBS_ORGANIZER_FETCH:
            return {
                ...state,
                isLoading: true,
                clubOrganizersLoaded: false,
            };
        case CLUBS_ORGANIZER_FETCH_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                clubOrganizersLoaded: true,
                clubOrganizers: action.data,
            };
        }
        case CLUBS_ORGANIZER_FETCH_FAILURE:
            return {
                ...state,
                isLoading: false,
                clubOrganizersLoaded: false,
                clubOrganizers: {},
            };

        case CLUBS_LATEST_EVENT_FETCH:
            return {
                ...state,
                isLoading: true,
                clubLatestEventsLoaded: false,
            };
        case CLUBS_LATEST_EVENT_FETCH_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                clubLatestEventsLoaded: true,
                clubLatestEvents: action.data,
            };
        }
        case CLUBS_LATEST_EVENT_FETCH_FAILURE:
            return {
                ...state,
                isLoading: false,
                clubLatestEventsLoaded: false,
                clubLatestEvents: [],
            };

        default:
            return state;
    }
}

export default app;
